import { gql } from '@apollo/client';

export const GET_MISSING_TIMESHEETS = gql`
  query GetMissingTimesheets(
    $tenantId: String!
    $clientId: String
    $startDate: String!
    $endDate: String!
  ) {
    getMissingTimesheets(
      tenantId: $tenantId
      clientId: $clientId
      startDate: $startDate
      endDate: $endDate
    ) {
      items {
        jobId
        jobTitle
        workType
        shiftDate
        scheduledStartTime
        scheduledEndTime
        siteId
        siteName
        clientId
        clientName
        userId
        workerName
        workerProfileImageUrl
      }
    }
  }
`;

export const BULK_SUBMIT_MISSING_TIMESHEETS = gql`
  mutation BulkSubmitMissingTimesheets(
    $input: BulkSubmitMissingTimesheetsInput!
  ) {
    bulkSubmitMissingTimesheets(input: $input) {
      attemptedCount
      submittedCount
      results {
        jobId
        dateISO
        success
        errorMessage
      }
    }
  }
`;
